export function getStatus(bid: number, isAccepted: boolean) {
  if (bid === 0 && isAccepted === false) {
    return "Place offer";
  }
  if (bid > 0) {
    return "Pending";
  }
}
